export const FETCH_USERS = 'FETCH_USERS'
export const ADD_USERS = 'ADD_USERS'
export const UPDATE_USERS = 'UPDATE_USERS'
export const REMOVE_USERS = 'REMOVE_USERS'

